import { render, staticRenderFns } from "./AbnormalUserList.vue?vue&type=template&id=efbedb2a&scoped=true"
import script from "./AbnormalUserList.vue?vue&type=script&lang=js"
export * from "./AbnormalUserList.vue?vue&type=script&lang=js"
import style0 from "./AbnormalUserList.vue?vue&type=style&index=0&id=efbedb2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efbedb2a",
  null
  
)

export default component.exports